<template>
<div v-if="equipes" >
   
<div v-for="equipe in equipes" v-show="isSearch(equipe) && isExists(equipe)" :class="getClassTeam(equipe)"   >
    <div :class="teamActif(equipe)" >
        <div class="teamDeastiveLabel">
            En attente de joueurs 
        </div>
        <div class="forcageDesactive">
            <s-button @onclick="forceActive(equipe)" label="forcer"
            icon="hammer" theme="is-dark"/>
        </div>
    </div>
     <div >
            
            <div class="team">
            <equipe 
                :equipe="equipe" 
                :joueurs="joueurs" 
                type="joueurs" 
                :changeFlagJoueur="changeFlagJoueur"
                @deleteJoueur="deleteJoueur"
                @changerJoueur="changerJoueur" 
                @changeEffect="changeEffect"
                 @selectJoueur="selectJoueur"
                 :role="role" 
                 :mode="tournoi.options.mode"
                 :options="tournoi.options"
                 :indexPartie = "indexPartie"
                 :showError = "showError"
                 :partie = "partie"
                 @saveScore="saveScore"
                 @openModalJoueur="openModalJoueur"
                 @openModalScore="openModalScore"
               
                 />
            </div>  
            <div class="vs" >
                <i class="fas fa-arrows-alt-h"></i><br/><br/>
            </div>
            <div class="teamVS" >
            <equipe 
                :equipe="equipe" 
                :joueurs="joueurs" 
                type="contre"
                :changeFlagJoueur="changeFlagJoueur"
                @deleteJoueur="deleteJoueur"
                @changerJoueur="changerJoueur" 
                 @changeEffect="changeEffect"
                 @selectJoueur="selectJoueur"
                :partie = "partie"
                :role="role" 
                :mode="tournoi.options.mode"
                :options="tournoi.options"
                :indexPartie = "indexPartie"
                 :showError = "showError"
                @saveScore="saveScore"
                @openModalJoueur="openModalJoueur"
                @openModalScore="openModalScore"
                
            />
            </div>
            
    </div>
    <div :class="'equipeGG G'+getGGGagne(equipe)" v-if="tournoi.options.GG && !activeTimer">
        ont gagné {{getGGGagne(equipe)}} partie(s)
    </div>
    <div :class="'equipeGGTimer G'+getGGGagne(equipe)" v-if="tournoi.options.GG && activeTimer">
         {{getGGGagne(equipe)}}
    </div>
    <div class="finish"  v-show="displayNormal(equipe) && hasEquipeJoueurs(equipe)" v-if="partie">
        <button-terrain
            v-if="zones!=null && equipe.terrain!=null"
            :zones="zones"
            :terrain="equipe.terrain.name"
            :zone="equipe.terrain.zone"
            :indexPartie="indexPartie"
            :parties="parties"
            @onclick="setOpenModalTerrain(equipe)"
            :role="role"
            :showDispo="false"
            :equipe="equipe"
        />
        <button-timer
            :equipe="equipe"
            :tournoi="tournoi"
            :club="club"
            :partie="partie"
            v-if="activeTimer"
            :nav="nav"
            :ref="'timer_'+equipe.id"
            @setTimer="setTimer(equipe)"
        />
        <s-button
             v-if="zones!=null && equipe.terrain==null"
            @onclick="setOpenModalTerrain(equipe)"
            label="En attente"
            icon=""
        />

        <span v-show="zones!=null">
            &nbsp;
        </span>
        <s-button v-show="equipe.state == 'FINISH'" 
             icon="lock-open" theme="is-danger" 
            :label="(zones!=null && tournoi.options.GG) || activeTimer ? '' : 'Déverouiler'" @onclick="deverouiller(equipe)" 
            :role = "role" 
            :disabled="disabledDeverouiller(equipe)"
            :id="'Deverouiller'+equipe.id"
            />
        <s-button v-show="equipe.state != 'FINISH' && equipe.score.joueurs!='' && equipe.score.joueurs!=null" 
             icon="save" theme="is-success" 
            :label="(zones!=null  && tournoi.options.GG) || activeTimer  ? '' : 'Enregistrer'" @onclick="saveScore(equipe)" 
            :role = "role" 
            :id="'saveScore'+equipe.id"
        />
        

    </div>
    
    <div class="finish" v-show="!hasEquipeJoueurs(equipe)">
        <s-button  
             icon="trash" theme="is-danger" 
            label="Supprimer" @onclick="deleteEquipe(equipe)" :role = "role" />
    </div>
    <div class="finishLater" v-show="!displayNormal(equipe)">
        <div v-if="tournoi.options.mode!='FORME'"> Ce joueur jouera dans <br/> dans une partie complémentaire</div>
        <div v-if="tournoi.options.mode=='FORME'"> Cette équipe jouera dans <br/> dans une partie complémentaire</div>
    </div>
  
</div>
    
    <div class="sfooter">
        &nbsp;
    </div>
</div>
</template>
<style scoped>
.forcageDesactive {
    position: absolute;
    bottom: 10px;
    right: 10px;
}
.equipeGGTimer {
    border-radius: 20px;
    background-color: rgb(241, 245, 236);
    float: left;
    margin-left: 1px;
    margin-right: 1px;
    margin-top: 4px;
    padding: 2px;
    width: 30px;
    font-size: 14px;
    font-weight: bolder;
    color: black;
}
.equipeGG {
    border-radius: 20px;
    background-color: rgb(241, 245, 236);
    float: left;
    margin-left: 10px;
    margin-top: 4px;
    padding: 2px;
    width: 130px;
    font-size: 14px;
    font-weight: bolder;
    color: black;
}
.G0 {
}
.G1 {
    background-color: rgb(223, 236, 174);
    color: black;
}
.G2 {
    background-color: rgb(183, 243, 87);
    color: black;
}
.G3 {
    background-color: rgb(114, 184, 1);
    color: black;
}
.G4 {
    background-color: rgb(72, 116, 2);
    color: white;
}
.arbitreTerrain {
    float: right;
    margin-right: 5px;
    height: 10px;
    
}

.stwaiting {
    background-color: orange;
}

.stinprogress {
    background-color: greenyellow;
}
.stfinish {
    background-color: rgb(20, 20, 20);
    color: white;
}
.sfooter {
    height: 40px;
    
}
 .team {
        display: inline-block;
        height: 160px;
        background-color: rgb(39, 121, 177);
        border-radius: 5px;
        width: 46%;
    }
.teamVS {
    display: inline-block;
    background-color: rgb(247, 77, 77);
    height: 160px;
     width: 46%;
    border-radius: 5px;
}
    .vs {
         display: inline-block;
        
         width: 20px;
         text-align: center;
    }
    .equipeItem {
        display: inline-block;
        margin-bottom: 20px;
        /*background-color: rgb(206, 206, 205);*/
        height: 215px;
        margin-left: 2px;
        margin-right: 2px;
        border-radius: 5px;
        padding: 3px;
        width: 98%;
        max-width: 400px;
        background-color: rgba(227, 224, 240, 0.3);
        vertical-align: top;
       /* border: thin silver solid;*/
    }
    .equipeItem:nth-child(odd) {
        background-color: rgba(247, 245, 245, 0.3);
        vertical-align: top;
    }
    .equipeNonActif {
        position: absolute;
        margin-bottom: 20px;
        background: linear-gradient( rgba(37, 6, 3, 0.2),rgba(37, 6, 3,0.7) );
        height: 215px;
      
        border-radius: 5px;
        padding: 3px;
        width: 100%;
        max-width: 400px;
        vertical-align: top;
        z-index: 100;
    }
    .equipeActif {
        display: none;
    }
    .teamDeastiveLabel {
        position: absolute;
        margin-left: auto;
        margin-right: auto;
        bottom: 60px;
        color: white;
        font-size: 30px;
        text-align: center;
        width: 100%;
    }
    .equipeFinish {
        display: inline-block;
        margin-bottom: 20px;
        background-color: rgb(90, 90, 90);
        height: 215px;
        margin-left: 2px;
        margin-right: 2px;
        border-radius: 5px;
        padding: 3px;
        width: 98%;
        max-width: 400px;
        vertical-align: top;
    }
    .equipePreFinih {
        display: inline-block;
        margin-bottom: 20px;
        background-color:rgb(169, 230, 169);
        height: 215px;
        margin-left: 2px;
        margin-right: 2px;
        border-radius: 5px;
        padding: 3px;
        width: 98%;
        max-width: 400px;
        vertical-align: top;
    }
    
    .finish {
      text-align: center;
      padding-top: 5px;
      padding-bottom: 5px;
      
    }
    .finishLater {
        height: 45px;
        font-size: 14px;
        font-style: italic;
        color: black;
        margin-top: 5px;
        background-color : rgb(230, 195, 80); 
    }
    .WAITING {
        color: rgb(35, 90, 161);
        padding-left: 5px;
    }
    .termine {
        color: rgb(243, 247, 244);
        padding-left: 5px;
    }
</style>
<script>
import equipe from "@/views/tournoi/inProgress/equipe.vue"
import tournoi_fct from '@/firebase/tournoi'
import firebase_api from '@/firebase/firebase_api'
import buttonTerrain from "@/views/tournoi/inProgress/buttonTerrain.vue"
import buttonTimer from "@/views/tournoi/inProgress/buttonTimer.vue"




export default {
    props: ["indexPartie", "tournoi", "joueurs", "search", "role","changeFlagJoueur","club","showError", "parties","nav"],
    components: {
        equipe,
        buttonTerrain,
        buttonTimer
    },
    computed: {
        zones: {
            get() {
                if (typeof(this.tournoi.options.zones)=="undefined") {
                    return null;
                }
                else if (Object.keys(this.tournoi.options.zones).length==0) {
                    return null
                }
                else
                    return this.tournoi.options.zones
            }
        },
        activeTimer: {
                get() {
                    if (typeof(this.tournoi.timer)=="undefined")
                        return false;
                    else
                        return this.tournoi.timer.active;
                }
            }
    },
    data() {
        return {
            equipes: null,
            partie: null,
            partieNext: null,
            openJoueurModify: false,
            joueurSelected: null,
            modalDeverouiller: false
        }
    },
    mounted() {
       var dataRefEquipes = firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                    .collection("parties").doc("P"+this.indexPartie).collection("equipes");
       /*if (this.zones != null) {
            this.$bind("equipesOrder", dataRefEquipes.orderBy("terrain.numero"))
                        .then(datas=> {
                            if (datas.length == 0) {
                                this.$bind("equipesOrder", dataRefEquipes.orderBy("ggGagnes", "desc")).then(datas2=>{
                                     if (datas2.length == 0) {
                                         this.$bind("equipesOrder", dataRefEquipes);
                                     }
                                })
                            }
                        })
       }
       else {
            this.$bind("equipesOrder", dataRefEquipes.orderBy("ggGagnes", "desc")).then(datas2=>{
                    if (datas2.length == 0) {
                                this.$bind("equipesOrder", dataRefEquipes);
                    }
            })
       }*/
       
       /*this.$bind("equipes", dataRefEquipes.orderBy("terrain.numero"))
                        .then(datas=>{
                            if (datas.length == 0) {
                                this.$bind("equipes", firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                                    .collection("parties").doc("P"+this.indexPartie).collection("equipes").orderBy("ggGagnes", "desc"))
                                    .then(datas2=>{
                                        if (datas2.length == 0) {
                                            this.$bind("equipes", firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                                                .collection("parties").doc("P"+this.indexPartie).collection("equipes"))
                                        }
                                    })
                            }
                        })
        */
          if (this.tournoi.options.GG) {
            this.$bind("equipes", dataRefEquipes.orderBy("ggGagnes","desc"));
        }
        else
            this.$bind("equipes", dataRefEquipes)
           
        this.$bind("partie", firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                    .collection("parties").doc("P"+this.indexPartie));
        this.$bind("partieNext", firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                    .collection("parties").doc("P"+(this.indexPartie+1)));
        
    },
    methods: {
        equipeFirestore(idEquipe) {
            var dataRefEquipes = firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                    .collection("parties").doc("P"+this.indexPartie).collection("equipes").doc(idEquipe);
            return dataRefEquipes;
        },
        setTimer(equipe) {
            
            this.$emit("setTimer",equipe);
        },
        stopTimer(equipeId) {
            if (equipeId == null) {
                this.equipes.forEach(equipe=>{
                    this.$refs['timer_'+equipe.id][0].stopTimer()
                })
            }
            else
                this.$refs['timer_'+equipeId][0].stopTimer()
            
        },
        setOpenModalTerrain(equipe) {
            this.$emit("setOpenModalTerrain", equipe);
        },
        openModalScore(equipe, type) {
          //  console.log(equipe);
          var errorOnLine = false;
         
            if (this.isOffline && typeof(this.tournoi.options.choiceWaitingPartie)!="undefined")
                errorOnLine = !this.tournoi.options.choiceWaitingPartie;

            if (!errorOnLine)
                this.$emit("openModalScore",equipe, type);
            else {
                alert("Il faut vous connecter sur internet");
            }
        },
        forceActive(equipe) {
            equipe.forcage = true;
            //this.$firestoreRefs.equipes.doc(equipe.id).set(equipe);
            this.equipeFirestore(equipe.id).set(equipe);
        },
       
        isExists(equipe) {
            return true;
            /*
            if (typeof(equipe.exists)=="undefined")
                return true;
            else if (equipe.exists == null)
                return true;
            else
                return equipe.exists;*/
        },
        disabledDeverouiller(equipe) {
            if (this.tournoi.state == "FINISH") {
                return true;
            }
            else {
                if (this.tournoi.options.allEquipePlay && this.tournoi.options.GG
                    && (typeof(this.tournoi.options.choiceWaitingPartie)=="undefined" 
                    || this.tournoi.options.choiceWaitingPartie) && this.partieNext!=null)
                    return true;
                else if (!this.tournoi.options.allEquipePlay && this.tournoi.options.GG) {
                    if (equipe.contre["J1"]==null && 
                        (this.equipeHasScore(equipe))
                    )
                    return true;
                }
                    return false;
            }
            
        },
        supprimerJoueursNext() {

        },
        modifyJustScore() {

        },
        openModalJoueur(errorDetail) {
            this.$emit("openModalJoueur", errorDetail)
        },
        deleteEquipe(equipe) {
            //this.$firestoreRefs
            this.equipeFirestore(equipe.id).delete().then(()=>{
                this.verifStatePartie(this.indexPartie);
            });

        },
        hasEquipeJoueurs(equipe) {
            var bool;
            bool = equipe.joueurs.J1 != null;
            bool = bool || equipe.joueurs.J2 != null;
            bool = bool || equipe.joueurs.J3 != null;
            bool = bool || equipe.contre.J1 != null;
            bool = bool || equipe.contre.J2 != null;
            bool = bool || equipe.contre.J3 != null;
            return bool;
        },
        getGGGagne(equipe) {
            return equipe.ggGagnes;
        },
         displayNormal(equipe) {
               
                if (this.tournoi.options) {
                    if (this.tournoi.options.allEquipePlay)
                        return true;
                    else if (this.tournoi.options.addPartie) {
                        if (equipe["joueurs"].J2 == null || equipe["contre"].J1==null)
                            return false;
                        else
                            return true;
                    }
                    else    
                        return true;
                    }
               else return true;
        },
        deverouiller(equipe) {
           
                this.partie.state = "INPROGRESS";
                equipe.state = this.partie.state;
                var score = equipe.score;
                
                delete score["validate"];
                delete score["idJoueur"];
                firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("tournois").doc(this.tournoi.id)
                    .collection("parties").doc(this.partie.id).update({
                    state : this.partie.state
                })
                //this.$firestoreRefs
                this.equipeFirestore(equipe.id).update({
                    state :  equipe.state,
                    score: score
                })
            
        },
        selectJoueur(joueurSelected, equipeSelected) {
            
            this.$emit("selectJoueur", joueurSelected, equipeSelected);
        },
        verifStatePartie(indexPartie) {
           var finish = true;
           this.equipes.forEach(equipe=>{
                finish = equipe.state == 'FINISH' && finish;
            })
            if (finish) {
                this.$firestoreRefs.partie.update({
                    state : "FINISH"
                })
            }
        },
        equipeHasScore(equipe) {
        // return true si le score est renseigné
        // false si le score n'est pas renseigné

            var val = parseInt(equipe.score.joueurs);
            if (!isNaN(val))
                return true;
            else
                return equipe.score.joueurs != null && equipe.score.joueurs != '';
        },
        teamActif(equipe) {
            if (!this.tournoi.options.choiceWaitingPartie) {
                if (typeof(equipe.forcage)!="undefined" && equipe.forcage)
                        return  'equipeActif';
                if (this.tournoi.options.GG && !this.tournoi.options.allEquipePlay) {
                
                    if (this.tournoi.options.mode=="ALEA") {
                        var compteurJoueurs = 0;
                        if (this.equipeHasScore(equipe))
                            return 'equipeActif';
                        for (var key in equipe.joueurs) {
                            if (equipe.joueurs[key]!=null)
                                compteurJoueurs++;
                        
                        }
                        for (var key in equipe.contre) {
                            if (equipe.contre[key]!=null)
                                compteurJoueurs++;
                        }
                    
                        if (compteurJoueurs == this.tournoi.options.nbJoueursParEquipe) {
                            if (equipe.score.joueurs == null || equipe.score.joueurs == '') {
                                return 'equipeNonActif'
                            }
                        }
                        else if (compteurJoueurs != this.tournoi.options.nbJoueursParEquipe*2) {
                            
                            return 'equipeNonActif'
                        }
                        else
                            return 'equipeActif'
                    }
                    else {
                        
                        if (equipe.joueurs["J1"] == null)
                            return 'equipeNonActif'
                        else if ((equipe.score.joueurs == null || equipe.score.joueurs == '')
                            && equipe.contre["J1"]==null)
                            return 'equipeNonActif';
                        else 
                            return 'equipeActif';
                    }

                }
                if (this.tournoi.options.GG && this.tournoi.options.allEquipePlay
                && typeof(this.tournoi.options.choiceWaitingPartie)!="undefined" && !this.tournoi.options.choiceWaitingPartie)  {
                if (this.indexPartie==0)
                        return 'equipeActif';
                    
                var compteurJoueurs = 0;
                
                    for (var key in equipe.joueurs) {
                        if (equipe.joueurs[key]!=null)
                            compteurJoueurs++;
                    }
                    for (var key in equipe.contre) {
                        if (equipe.contre[key]!=null)
                            compteurJoueurs++;
                    }
                    if (typeof(equipe.forcage)!="undefined" && equipe.forcage)
                        return  'equipeActif';
                    if (typeof(equipe.triplette)!="undefined" && equipe.triplette!=null) {
                        if (equipe.triplette.state) {
                            if (equipe.triplette.nb == 1) {
                                if (compteurJoueurs==5)
                                    return 'equipeActif'
                                else
                                    return 'equipeNonActif'
                            }
                            if (equipe.triplette.nb == 2) {
                                if (compteurJoueurs==6)
                                    return 'equipeActif'
                                else
                                    return 'equipeNonActif'    
                            }
                            if (equipe.triplette.nb == 0) {
                                if (compteurJoueurs==4)
                                    return 'equipeActif'
                                else
                                    return 'equipeNonActif'    
                            }
                        }
                        else
                            return 'equipeNonActif';
                    }
                    else {
                        if (compteurJoueurs==4)
                            return 'equipeActif'
                        else
                            return 'equipeNonActif'    
                    }
                }
            }
            return 'equipeActif'
        },
        getClassTeam(equipe) {
            
            if (this.partie!=null) {
                if (this.displayNormal(equipe)) {
                    if (this.partie.state == "FINISH") 
                    return 'equipeFinish';
                    else if (this.isReady(equipe))
                        return 'equipePreFinih';
                    else
                        return 'equipeItem';
                }
                else
                    return 'equipeFinish';
            }
            else
                return '';
        },
        isReady(equipe) {   
           
            return (equipe.score.contre == this.tournoi.winAt) || (equipe.score.joueurs == this.tournoi.winAt) 
        },
         findName (joueur) {
            if (this.joueurs[joueur.numero].pseudo.toUpperCase().indexOf(this.search.toUpperCase()) != -1)
                return true;
            else if (this.joueurs[joueur.numero].nom.toUpperCase().indexOf(this.search.toUpperCase()) != -1)
                return true;
            else 
                return this.joueurs[joueur.numero].prenom.toUpperCase().indexOf(this.search.toUpperCase()) != -1
        },
        isSearch(equipe) {
            var bool = false;
            if (this.search == "")
                bool = true;
            else if (!isNaN(this.search)) {
                if (equipe.joueurs.J1)
                    bool = parseInt(equipe.joueurs.J1.numero)+1 == parseInt(this.search);
               
                if (!bool) {
                    if (equipe.joueurs.J2)
                    bool = parseInt(equipe.joueurs.J2.numero)+1 == parseInt(this.search)
                }
                
                if (!bool) {
                    if (equipe.joueurs.J3)
                    bool = parseInt(equipe.joueurs.J3.numero)+1 == parseInt(this.search)
                }

                if (!bool) {
                    if (equipe.contre.J1)
                    bool = parseInt(equipe.contre.J1.numero)+1 == parseInt(this.search)
                   
                }
                if (!bool) {
                    if (equipe.contre.J2)
                    bool = parseInt(equipe.contre.J2.numero)+1 == parseInt(this.search)
                    
                }
                 if (!bool) {
                     if (equipe.contre.J3)
                    bool = parseInt(equipe.contre.J3.numero)+1 == parseInt(this.search)
                    
                }
            }
            else {
                bool = false;
                if (equipe.joueurs.J1)
                bool = this.findName (equipe.joueurs.J1);
                if (!bool)
                    if (equipe.joueurs.J2)
                    bool = this.findName (equipe.joueurs.J2);
                if (!bool)
                if (equipe.joueurs.J3)
                    bool = this.findName (equipe.joueurs.J3);
                if (!bool)
                if (equipe.contre.J1)
                    bool = this.findName (equipe.contre.J1);
                if (!bool)
                if (equipe.contre.J2)
                    bool = this.findName (equipe.contre.J2);
                 if (!bool)
                 if (equipe.contre.J3)
                    bool = this.findName (equipe.contre.J3);
            }
            return bool;
        },
       
        deleteJoueur( joueur, equipe) {
            this.$emit("deleteJoueur")
        },
        changerJoueur( joueur, equipe) {
            this.$emit("changerJoueur", joueur, equipe)
        },
        changeEffect(joueur, equipe) {
           
            this.$emit("changeEffect", joueur, equipe);
        },
        addJoueursEquipeVS(equipeVS, listJoueursEquipe) {
            for (var joueur in equipeVS) {
                if (equipeVS[joueur] != null)
                    listJoueursEquipe.push(equipeVS[joueur].numero);
            }
        },
        testJoueurPartieNext(equipe, fct) {
            var idPartie = "P" + (this.indexPartie+1);
            var listJoueursEquipe = [];
            var equipesRefSave = [];
            var equipeIsTriplette = equipe.triplette!=null;
            var equipeGGgagnes = equipe.ggGagnes;
            this.addJoueursEquipeVS(equipe.joueurs, listJoueursEquipe);
            this.addJoueursEquipeVS(equipe.contre, listJoueursEquipe);

            firebase_api.api.getDb().collection("club").doc(this.club.id)
                .collection("tournois").doc(this.tournoi.id)
                .collection("parties").doc(idPartie).get().then(partie=>{
                            if (partie.exists) {
                               
                                partie.ref.collection("equipes").get().then(equipesRef=>{
                                   
                                    var flagEquipeNextFinish = false;
                                    
                                    equipesRef.docs.forEach(equipeRef=>{
                                        if (!flagEquipeNextFinish) {
                                            var equipeData = equipeRef.data();
                                            var listJoueursEquipeCurrent = [];
                                            this.addJoueursEquipeVS(equipeData.joueurs, listJoueursEquipeCurrent);
                                            listJoueursEquipeCurrent.forEach(joueurNumero=>{
                                                if (listJoueursEquipe.indexOf(joueurNumero)!=-1) {
                                                    if (equipeData.score.joueurs!= null && equipeData.score.joueurs!='') {
                                                       
                                                        if (equipeData.contre.J1!=null)
                                                            flagEquipeNextFinish=true;   
                                                        else {
                                                            equipesRefSave.push(equipeRef);
                                                        }                                                     
                                                    }
                                                    else {
                                                        equipesRefSave.push(equipeRef);
                                                    }
                                                }
                                            })
                                            if (listJoueursEquipeCurrent.length == 3) {
                                                equipesRefSave.push(equipeRef);
                                                listJoueursEquipe.push(listJoueursEquipeCurrent[2]);
                                            }
                                            listJoueursEquipeCurrent = [];
                                            this.addJoueursEquipeVS(equipeData.contre, listJoueursEquipeCurrent);
                                            listJoueursEquipeCurrent.forEach(joueurNumero=>{
                                                if (listJoueursEquipe.indexOf(joueurNumero)!=-1) {
                                                    if (this.equipeHasScore(equipeData)) {
                                                       
                                                        if (equipeData.contre.J1!=null)
                                                            flagEquipeNextFinish=true;   
                                                        else {
                                                            equipesRefSave.push(equipeRef);
                                                        }                                                     
                                                    }
                                                    else {
                                                        equipesRefSave.push(equipeRef);
                                                    }
                                                }
                                            })
                                            if (listJoueursEquipeCurrent.length == 3) {
                                                equipesRefSave.push(equipeRef);
                                                listJoueursEquipe.push(listJoueursEquipeCurrent[2]);
                                            }
                                            if (equipeIsTriplette && equipeData.triplette!=null) {
                                                if (equipeData.ggGagnes == equipeGGgagnes)
                                                    equipesRefSave.push(equipeRef);
                                                if (equipeData.ggGagnes == equipeGGgagnes+1)
                                                    equipesRefSave.push(equipeRef);
                                            }
                                            if (equipeData.ggGagnes == equipeGGgagnes || equipeData.ggGagnes == equipeGGgagnes+1) {
                                                if (equipeData.exists!=null) {
                                                    if (this.equipeHasScore(equipeData)) {
                                                        flagEquipeNextFinish = true;
                                                    }
                                                    else {
                                                        this.addJoueursEquipeVS(equipeData.joueurs, listJoueursEquipe);
                                                        this.addJoueursEquipeVS(equipeData.contre, listJoueursEquipe);
                                                        equipesRefSave.push(equipeRef);
                                                    }
                                                }
                                            }
                                        }
                                    })
                                    if (flagEquipeNextFinish) {
                                        fct(false); // On peut Rien faire
                                    }
                                    else {
                                        fct(true, listJoueursEquipe, equipesRefSave);
                                    }
                                        
                                })
                            }
                            else {
                                fct(null);
                            }
                        })
        },
        saveScoreOK (equipe) {
           
            var flag = true;
            if (equipe.score['joueurs'] == '' || equipe.score['contre']=='')
                flag = false;
            if (equipe.score['joueurs'] == '0' || equipe.score['contre']=='0')
                flag = true;
             if (flag) {
                if (!isNaN(equipe.score['joueurs']))
                    equipe.score['joueurs'] = parseInt(equipe.score['joueurs']);
                if (!isNaN(equipe.score['joueurs']))
                    equipe.score['contre'] = parseInt(equipe.score['contre']);
                if (equipe.score['joueurs'] >= 0 && equipe.score['contre'] >=0) {
                    equipe.state = "FINISH";
                   
                    //this.$firestoreRefs
                    this.equipeFirestore(equipe.id).set(equipe).then(equipeSet=>{
                        // on vérifie si on en mode Gagnant gagnant et si la règle des joueurs 
                        
                        if (this.tournoi.options.GG) {
                          
                            var bool = false;
                            if (typeof(this.tournoi.options.choiceWaitingPartie)!='undefined')
                                bool = !this.tournoi.options.choiceWaitingPartie;
                            
                            // si on est dans ce cas, il faut ajouter de suite la partie
                            // avec les joueurs qui ont gagné pour qu'il puisse commencer à jouer !
                            if (bool)
                                tournoi_fct.object.setTournoiGG(this.club, this.tournoi, this.indexPartie, equipe)
                        }
                    });
                    this.verifStatePartie(this.indexPartie)
                }
            }
            else {
                
                 this.equipeFirestore(equipe.id).set(equipe);
            }
        },
        saveScore(equipe) {
            var saveScore = true;
            
            if (this.tournoi.options.GG && 
                (!this.tournoi.options.allEquipePlay ||
                this.tournoi.options.allEquipePlay && 
                typeof(this.tournoi.options.choiceWaitingPartie) != "undefined" &&
                !this.tournoi.options.choiceWaitingPartie))
                {
                   
                
                this.equipeFirestore(equipe.id).get().then(equipeRef=>{
                   
                    if (equipeRef.exists) {
                        var equipeOld = equipeRef.data();
                        saveScore = false;
                        
                        if (!this.equipeHasScore(equipeOld)) {
                            saveScore = true;
                        }
                        else {
                            var newScoreContre = 0;
                            var newScoreJoueur = 0;
                            if (!isNaN(equipe.score['joueurs']))
                                newScoreJoueur = parseInt(equipe.score['joueurs']);
                            if (!isNaN(equipe.score['joueurs']))
                                newScoreContre = parseInt(equipe.score['contre']);
                            equipeOld.score['joueurs'] = parseInt(equipeOld.score['joueurs']);
                            equipeOld.score['contre'] = parseInt(equipeOld.score['contre']);
                            var joueurWin = newScoreJoueur > newScoreContre;
                            var joueurWinOld = equipeOld.score['joueurs']  > equipeOld.score['contre'];
                       
                            if (!isNaN(newScoreJoueur) && (joueurWin == joueurWinOld)) {
                                saveScore = true;
                            }
                           
                        }
                               
                    }
                    
                    if (saveScore) {
                       
                        this.saveScoreOK(equipe);
                    }
                    else {
                        // vérifier l'état des parties d'après !!!
                      
                        //TODO bon il faut vérifier que le nouveau score n'est pas vide ou null
                            // car ca veut dire que c'est en cours 
                            // si c'est le cas on ne fait rien pour l'instant
                            // si le novueau score est modifié il faut tester si les joueurs de ce jeur
                            // ont un score dans la partie d'après
                            // si c'est le cas alors là il y a un petit problème
                            // on n'envoie un messge
                            // sinon on va devoir supprimer les joueurs des équipes de la partie suivntes
                            // et sauvegarder ... quel bordel ...
                       
                            this.testJoueurPartieNext(equipe, (sup, listJoueursEquipe, equipesRef)=>{
                               
                                if (sup==null) {
                                   // this.$firestoreRefs.equipes
                                    this.equipeFirestore(equipe.id).set(equipe);
                                }
                                // si par contre le test est
                                else if (sup) {
                                    
                                    if (typeof(equipesRef)!="undefined") {
                                        equipesRef.forEach((equipeRef, indiceEquipeRef)=>{
                                            var equipeData =  equipeRef.data();

                                            for (var key in equipeData.joueurs) {
                                                    if (equipeData.joueurs[key]!=null) {
                                                        if ((listJoueursEquipe.indexOf(equipeData.joueurs[key].numero)!=-1
                                                            && equipeData.exists == null) 
                                                            || equipeData.exists)
                                                         {
                                                            equipeData.joueurs[key] = null;
                                                            if (equipeData.contre["J1"]!=null 
                                                                &&  (equipeData.score.joueurs!='' &&
                                                                equipeData.score.joueurs!=null)) {
                                                                    equipeData.score.joueurs = '';
                                                                    equipeData.score.contre = '';
                                                                }
                                                            else
                                                                equipeData.state = "INPROGRESS";
                                                            
                                                            if (typeof(equipeData.triplette)!="undefined")
                                                                if (equipeData.triplette!=null)
                                                                    equipeData.triplette.state = false;
                                                             if (equipeData.exists!=null)
                                                                    equipeData.exists = false;
                                                            equipeRef.ref.set(equipeData);
                                                        }
                                                    }
                                            }
                                            for (var key in equipeData.contre) {
                                                    if (equipeData.contre[key]!=null) {
                                                        if ((listJoueursEquipe.indexOf(equipeData.contre[key].numero)!=-1
                                                        && equipeData.exists == null) 
                                                            || equipeData.exists)
                                                         {
                                                            equipeData.contre[key] = null;
                                                            equipeData.score.joueurs = '';
                                                            equipeData.score.contre = '';
                                                            equipeData.state = "INPROGRESS";
                                                            if (typeof(equipeData.triplette)!="undefined")
                                                                if (equipeData.triplette!=null)
                                                                    equipeData.triplette.state = false;
                                                            if (equipeData.exists!=null)
                                                                equipeData.exists = false;
                                                            equipeRef.ref.set(equipeData);
                                                        }
                                                    }
                                            }
                                            if (equipe.triplette!=null && equipeData.triplette!=null) {
                                                
                                                if (equipe.triplette.ggGagnes ==  equipeData.triplette.ggGagnes)
                                                    equipeData.triplette.state = false;
                                                if (equipe.triplette.ggGagnes ==  equipeData.triplette.ggGagnes+1)
                                                    equipeData.triplette.state = false;
                                            }
                                            
                                            if (indiceEquipeRef == equipesRef.length-1) {
                                                this.$emit("modalErreurGG", true);
                                                this.saveScoreOK(equipe);    
                                            }
                                        })
                                        if (equipesRef.length==0) {
                                            
                                            this.saveScoreOK(equipe);
                                        }
                                    }
                                }
                                else {
                                    
                                    this.$emit("modalErreurGG", false);
                                    equipe.score['joueurs'] = equipeOld.score['joueurs'] ;
                                    equipe.score['contre'] = equipeOld.score['contre'] ;
                                    this.saveScoreOK(equipe);
                                }
                            
                            });
                        
                    }          
                })
            }
            else {
                
                this.saveScoreOK(equipe);
            }
        },
        eraserScore(equipe) {
            equipe.score['joueurs'] = '';
            equipe.score['contre'] = '';
            this.saveScore(equipe);
            //this.$firestoreRefs.equipes.doc(equipe.id).set(equipe);
            //this.verifStatePartie(this.indexPartie)
        }
    }
}
</script>